import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import RichTextEditor from 'Components/UI/RichTextEditor';

const styles = () => ({
  root: {
    width: '100%',
  },
});

const GoalFormDescriptionField = ({ className, classes, ...rest }) => {
  return (
    <RichTextEditor
      className={classNames(classes.root, className)}
      size="sm"
      {...rest}
    />
  );
};

export default withStyles(styles)(GoalFormDescriptionField);
